import { Row, Col, Input, Modal } from "antd";
import { useState, useEffect } from "react";
import CustomerGridItem from "../../components/CustomerGrid";
import CircularProgress from "../../components/CircularProgress";
import { GetCustomers } from "../../API/customer";
import Classes from "./index.module.css";
const Search = Input.Search;

const ErrorModal = Modal.error;
// const CustomerData = [];
// for (let i = 1; i < 101; i++) {
//   CustomerData.push({
//     name: "مشتری " + i,
//     id: i,
//     address: "آدرس " + i,
//     tel: "32598748",
//     phone: "09140985672",
//     cashBalance: null,
//     chequeBalance: "3000",
//     maxOpeninvoices: "3",
//     maxDaysForCheque: "5",
//     cashAccountBalance: "50000",
//     status: Math.floor(Math.random() * 1),
//     invoiceCount: 3,
//     chequeAccountBalance: 12,
//   });
// }
export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [displayedCustomers, setDisplayedCustomers] = useState(customers);
  const [Loading, setLoading] = useState(true);
  useEffect(() => {
    GetCustomers()
      .then((i) => {
        setCustomers(i);
        setDisplayedCustomers(i);
      })
      .finally(() => {
        setLoading(false);
      })
      .catch((i) => {
        ErrorModal({
          title: "خطا",
          content: "مشکلی هنگان انجام عمیلات رخداد"+i,
          okText: "باشد",
          okType: "danger",
          onOk() {},
        });
      });
  }, []);
  const onSearch = (value, _e, info) => {
    setDisplayedCustomers(
      customers.filter((i) => {
        if (
          i.name.toString().includes(value) ||
          i.id.toString().includes(value)
        ) {
          return i;
        }
      })
    );
  };
  return (
    <>
      <Row className={Classes.searchForm}>
        <Search
          placeholder="جستوجو نام و کد"
          onSearch={onSearch}
          allowClear
          enterButton
        />
      </Row>
      <Row>
        {Loading && <CircularProgress />}
        {displayedCustomers.map((i) => {
          return (
            <Col span={24}>
              <CustomerGridItem {...i} />
            </Col>
          );
        })}
      </Row>
    </>
  );
}
